import React, { useEffect } from 'react';
import { useToast } from '../features/toast';

const toastToneStyles = {
  success: {
    container: 'border-green-200 bg-green-50 text-green-700',
    button: 'bg-green-100 text-green-700 hover:bg-green-200',
  },
  info: {
    container: 'border-blue-200 bg-blue-50 text-blue-700',
    button: 'bg-blue-100 text-blue-700 hover:bg-blue-200',
  },
  error: {
    container: 'border-red-200 bg-white text-red-700',
    button: 'bg-red-100 text-red-700 hover:bg-red-200',
  },
};

const ToastViewport = () => {
  const { toast, dismissToast } = useToast();

  useEffect(() => {
    if (!toast) {
      return undefined;
    }
    const duration =
      typeof toast.duration === 'number' && toast.duration >= 0 ? toast.duration : 6000;
    if (duration === 0) {
      return undefined;
    }
    const timeoutId = window.setTimeout(() => {
      dismissToast();
    }, duration);
    return () => window.clearTimeout(timeoutId);
  }, [toast, dismissToast]);

  if (!toast) {
    return null;
  }

  const activeToastStyle = toastToneStyles[toast.tone] || toastToneStyles.error;

  return (
    <div
      className={`fixed top-24 left-1/2 z-[80] w-[92%] max-w-md -translate-x-1/2 rounded-2xl px-5 py-3 text-sm font-medium shadow-lg backdrop-blur ${
        activeToastStyle?.container ?? ''
      }`}
    >
      <div className="flex items-center justify-between gap-3">
        <span className="flex-1">{toast.message}</span>
        <button
          type="button"
          onClick={dismissToast}
          className={`rounded-full px-2.5 py-1 text-xs font-semibold transition ${
            activeToastStyle?.button ?? ''
          }`}
          aria-label="Dismiss notification"
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default ToastViewport;
